export default "query EmailValidationRules($locale:Locale!){validationRules:validationRules_v2(locale:$locale){email{...ValidationRuleAttributes}}}"